<template>
  <div class="DiceField">
    <vaudio ref="audio" :src="getDiceSe()" :muted="muted" :volume="50" :loop="false" :autoplay="false"></vaudio>
    <div class="Dices" v-if="getDiceImages(diceMsg).length > 0" v-for="(diceMsg, diceNum) in filterdShowDices" :key="diceMsg.key" :style="{ top: diceNum * 128 + 'px'}">
      <span v-if="enableDiceImg">
        <span class="result" :ref="diceMsg.key" :class="{success: !diceMsg.secret && diceMsg.extend.calc.result === true, failed: !diceMsg.secret && diceMsg.extend.calc.result === false }">
          <!-- <figure v-if="get(diceMsg.from)" class="icon"><img :src="src(get(diceMsg.from).imageKey)" alt=""></figure> -->
          <span v-if="get(diceMsg.from)">{{get(diceMsg.from).name}} → </span>
          {{result(diceMsg)}}
        </span>
        <span v-for="(imgSrc, j) in getDiceImages(diceMsg)" :key="j">
          <img v-if="imgSrc" :ref="diceMsg.key + '&' + j" :src="imgSrc" class="diceImage" @click="remove(diceMsg)" v-anime="getAnime(j, diceMsg)">
        </span>
      </span>
    </div>
    <svg class="svg" >
      <path ref="diceOrbit" fill="none" stroke="currentColor" stroke-width="0" d="M 650 450 Q 550 0 450 150 Q 400 50 350 150 Q 300 50 250 150 Q 200 50 150 150 Q 100 50 50 150"></path>
    </svg>
  </div>
</template>

<script>
import vaudio from '../common/audio'

export default {
  components: { vaudio },
  data() {
    return {
      deletedDices: [],
    }
  },
  mounted() {
    this.$store.commit('local/set', { key: 'diceTimestamp', value: Date.now() })
  },
  watch: {
    showDices(next, prev) {
      if (prev.length > next.length) return
      if (prev[prev.length - 1] === next[next.length - 1]) return
      this.playSe()
    }
  },
  methods: {
    playSe() {
      if (this.$refs.audio && this.enableDiceSe) {
        this.$refs.audio.play()
      }
    },
    remove(diceMsg) {
      if (diceMsg.timestamp && typeof diceMsg.timestamp.toMillis === 'function') {
        this.$store.commit('local/set', { key: 'diceTimestamp', value: diceMsg.timestamp.toMillis() })
      }
      /*
      this.$data.deletedDices.push(diceMsg)
      if (this.showDices.length === 0) {
        this.$data.deletedDices.length = 0
        this.$store.commit('local/set', { key: 'diceTimestamp', value: Date.now() })
      }
      */
    },
    makeDiceImg(type, _role, diceVisualType) {
      const role = _role === 0 ? 10 : _role
      // const { diceType } = this || 'default'
      return require(`../../../assets/dice/image/${diceVisualType}/${type}/${type}[${role}].png`)
    },
    getDiceImages(diceMsg) {
      if (diceMsg.secret) {
        return [require("../../../assets/dice/image/unknown.png")]
      }
      let retImgs = []
      const t = diceMsg.timestamp ? diceMsg.timestamp.toMillis() : 0;
      let diceVisualType = 'default'
      if (t % 100 >= 98) {
        diceVisualType = 'frost'
      }
      else if (t % 100 >= 96) {
        diceVisualType = 'clear'
      }
      diceMsg.extend.calc.dice.forEach( dice => {
        switch (dice.type) {
          case 'dice 4':
            retImgs.push(this.makeDiceImg('4_dice', dice.role, diceVisualType))
            break
          case 'dice 6':
            retImgs.push(this.makeDiceImg('6_dice', dice.role, diceVisualType))
            break
          case 'dice 8':
            retImgs.push(this.makeDiceImg('8_dice', dice.role, diceVisualType))
            break
          case 'dice 10':
            retImgs.push(this.makeDiceImg('10_dice', dice.role, diceVisualType))
            break
          case 'dice 12':
            retImgs.push(this.makeDiceImg('12_dice', dice.role, diceVisualType))
            break
          case 'dice 20':
            retImgs.push(this.makeDiceImg('20_dice', dice.role, diceVisualType))
            break
          case 'dice 100':
            retImgs.push(this.makeDiceImg('100_dice', Math.floor(dice.role/10), diceVisualType))
            retImgs.push(this.makeDiceImg('10_dice', dice.role%10, diceVisualType))
            break
          default:
            return false
        }
      })
      return retImgs.slice(0, 30)
    },
    getDiceSe() {
      return require("../../../assets/dice/sound/dice_role.mp3");
    },
    getAnime(index,diceMsg) {
      const path = this.$anime.path(this.$refs.diceOrbit)

      return {
        translateX: path('x'),
        translateY: path('y'),
        rotate: '-10turn',
        easing: 'easeOutQuart',
        elasticity: 800,
        duration: 2000,
        loop: false,
        delay: index * 100,
        begin: (anim) => {
          const el = this.$refs[diceMsg.key+ '&' + index][0]
          if (el) {
            el.style.visibility = 'visible'
          }
        },
        complete: (anim) => {
          if (index === 0) {
            const el = this.$refs[diceMsg.key][0]
            if (el) {
              const elStyle = window.getComputedStyle(el)
              const left = elStyle.getPropertyValue('left')
              const width = elStyle.getPropertyValue('width')
              el.style.left = String(parseInt(left,10) - (parseInt(width,10)/2)) + 'px'
              el.style.visibility = 'visible'
            }
          }
        }
      }
    },
    result(diceMsg) {
      if (diceMsg.secret) {
        return 'Secret Dice'
      }
      if (diceMsg.extend.calc.result === true) {
        return '成功'
      }
      if (diceMsg.extend.calc.result === false) {
        return '失敗'
      }
      return diceMsg.extend.calc.result
    },
  },
  computed: {
    showDices() {
      return this.$store.getters['messages/getChannelMessages']('*').filter( (message) => {
        return ( !!message.extend.calc &&
                 message.extend.calc.dice.length > 0 &&
                 (message.timestamp && message.timestamp.toMillis() > this.diceTimestamp) &&
                 this.$data.deletedDices.indexOf(message) === -1
        )
      }).slice(-10)
    },
    filterdShowDices () {
      const showDiceType = ['dice 4', 'dice 6', 'dice 8', 'dice 10', 'dice 12', 'dice 20', 'dice 100']
      return this.showDices.filter( (diceMsg) => {
        return showDiceType.indexOf(diceMsg.extend.calc.dice[0].type) !== -1
      })
    },
    get() {
      return this.$store.getters['characters/$get']
    },
    src() {
      return this.$store.getters['images/getSrc']
    },
    enableDiceImg() {
      return this.$store.getters['local/enableDiceImg']
    },
    enableDiceSe() {
      return this.$store.getters['local/enableDiceSe']
    },
    diceTimestamp() {
      return this.$store.getters['local/diceTimestamp']
    },
    muted() {
      return this.$store.getters['local/muted']
    },
    diceType() {
      return this.$store.getters['local/diceType']
    },
  }
}
</script>

<style scoped>
.DiceField {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  top: 30px;
  left: 300px;
  pointer-events: none;
}
.DiceField .Dices{
  position: absolute;
  display: block;
  max-width: 640px;
  pointer-events: none;
}
.DiceField .Dices .diceImage {
  width: 64px;
  cursor: pointer;
  pointer-events: auto;
  visibility: hidden;
}
.DiceField .Dices .result {
  position: absolute;
  padding: 5px;
  border-radius: 5px;
  display: inline-block;
  line-height: 1;
  background: #fff;
  color: #444;
  font-size: 20px;
  font-weight: 800;
  text-align: center;
  top: 110px;
  left: 75px;
  white-space: nowrap;
  visibility: hidden;
}
.DiceField .Dices .result.failed {
  color: #fff;
  background: rgba(215, 0, 0, 0.4);
}
.DiceField .Dices .result.success {
  color: #fff;
  background: rgba(0, 215, 0, 0.4);
}
.DiceField .svg{
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

</style>
